import { Link } from "react-router-dom";
import { type ReactNode } from "react";
import { Button } from "../components/ui/Button";
import {
  Hero,
  Features,
  Stats,
  Integration,
  Security,
  SocialProof,
  ROICalculator,
  CTA,
  Navigation,
  Footer,
} from "./Landing/components";

export function Landing() {
  const renderButton = (
    to: string,
    children: ReactNode,
    variant?: "primary" | "secondary" | "ghost",
  ) => (
    <Link to={to} className="w-full sm:w-auto">
      <Button size="lg" variant={variant}>
        {children}
      </Button>
    </Link>
  );

  return (
    <div className="min-h-screen bg-[#030014] text-white">
      <Navigation renderButton={renderButton} />
      <Hero renderButton={renderButton} />
      <SocialProof />
      <Features />
      <ROICalculator />
      <Stats />
      <Security />
      <Integration />
      <CTA renderButton={renderButton} />
      <Footer />
    </div>
  );
}
